module.exports = __webpack_public_path__ + "e276ce4ceeed4d2c99aa3faa252be4e7.png";